import * as React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { CoreConstants } from "../../../core/models/constants/core.constants";
import DynamicForm from "../../../core/presentations/DynamicForm";
import { useToasterFacade } from "../../../ui/facades/toaster.facade";
import Validators from "../../../ui/helpers/validators";
import TopLabelFieldTemplate from "../../../ui/templates/fields/TopLabelFieldTemplate";
import VerticalFormTemplate from "../../../ui/templates/objects/VerticalFormTemplate";
import PrwcBasicButton from "../../../ui/widgets/custom/buttons/PrwcBasicButton";

const SetPassword = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const toasterFacade = useToasterFacade();
  const [formData, setFormData] = useState(null);

  const onChange = (formData: any) => {
    setFormData(formData);
  };

  const validationSchema: any = {
    workEmailId: {
      validators: [
        {
          validate: (value: string) => {
            return !Validators.isStringEmpty(value);
          },
          messageKey: "setPassword.validation.workEmailRequired",
        },
        {
          validate: (value: string) => {
            return Validators.isRegexPatternValid(
              CoreConstants.REGEX_EMAIL,
              value
            );
          },
          messageKey: "setPassword.validation.workEmailInvalid",
        },
        {
          validate: (value: string) => {
            return !Validators.isPersonalEmail(value);
          },
          messageKey: "setPassword.validation.workEmailNotWorkEmail",
        },
      ],
    },
    password: {
      validators: [
        {
          validate: (value: string) => {
            return !Validators.isStringEmpty(value);
          },
          messageKey: "setPassword.validation.passwordRequired",
        },
        {
          validate: (value: string) => {
            return Validators.isRegexPatternValid(
              CoreConstants.REGEX_PASSWORD,
              value
            );
          },
          messageKey: "setPassword.validation.invalidPassword",
        },
      ],
    },
  };

  const schema: any = {
    type: "object",
    properties: {
      workEmailId: {
        type: "string",
        title: t("setPassword.label.workEmailId"),
        default: "",
      },
      password: {
        type: "string",
        title: t("setPassword.label.password"),
      },
    },
    required: ["workEmailId"],
  };

  const uiSchema: any = {
    "ui:ObjectFieldTemplate": VerticalFormTemplate,
    workEmailId: {
      "ui:widget": "prwInputText",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12",
    },
    password: {
      "ui:widget": "prwPassword",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12",
      "ui:options": {
        showFeedback: true,
      },
    },
  };

  const onSubmit = (data: any) => {
    toasterFacade.showSuccess(
      t("setPassword.msg.success.passwordSetSuccessfully")
    );
    history.push("signin");
  };

  const onError = (data: any) => {};

  const formButtons = () => {
    return (
      <PrwcBasicButton
        type="submit"
        labelKey="setPassword.action.confirmPassword"
        className="bg-blue-700 p-col-12 p-button-sm"
      ></PrwcBasicButton>
    );
  };

  return (
    <div className="p-6 bg-gray-100 rounded-md">
      <div className="text-2xl font-semibold">
        {t("setPassword.label.setPassword")}
      </div>
      <div className="text-sm ">
        {t("setPassword.label.typeInYourPassword")}
      </div>
      <div className="mt-4">
        <DynamicForm
          onChange={onChange}
          formData={formData}
          onSubmit={onSubmit}
          onError={onError}
          schema={schema}
          uiSchema={uiSchema}
          validationSchema={validationSchema}
          formButtons={() => formButtons()}
        ></DynamicForm>
      </div>
    </div>
  );
};

export default SetPassword;
